import { render, staticRenderFns } from "./HomeInfo.vue?vue&type=template&id=cd53bcb6&scoped=true"
import script from "./HomeInfo.vue?vue&type=script&lang=js"
export * from "./HomeInfo.vue?vue&type=script&lang=js"
import style0 from "./HomeInfo.vue?vue&type=style&index=0&id=cd53bcb6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd53bcb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd53bcb6')) {
      api.createRecord('cd53bcb6', component.options)
    } else {
      api.reload('cd53bcb6', component.options)
    }
    module.hot.accept("./HomeInfo.vue?vue&type=template&id=cd53bcb6&scoped=true", function () {
      api.rerender('cd53bcb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/HomeInfo/HomeInfo.vue"
export default component.exports